import ComingSoonCover from "@/components/ComingSoonCover";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/fleets/_layout/overview")({
  component: () => {
    return <ComingSoonCover />;
  },
});
